export default async function GetAllGender(data) {
    let url = window.RealestateService + "/api/Land/GetAllGender";
    let head = {
        "content-type": "application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response;
}